export const GITHUB_URL = 'https://github.com/fabianhinz/PaceVault';
